import React, { useState } from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer';
import Newsletter from '../components/Newsletter';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronRight,
    faChevronDown,
    faEnvelope,
    faBriefcase,
    faUsers,
    faStar,
    faShieldAlt,
    faClock,
    faAward,
} from "@fortawesome/free-solid-svg-icons";

const AccordionItem = ({ title, children }) => {
    const [open, setOpen] = useState(false);

    return (
        <div className={`tc-accordion-item ${open ? 'tc-accordion-open' : ''}`}>
            <button className="tc-accordion-trigger" onClick={() => setOpen(!open)}>
                <span>{title}</span>
                <span className={`tc-accordion-icon ${open ? 'rotated' : ''}`}>
                    <FontAwesomeIcon icon={faChevronDown} />
                </span>
            </button>
            <div className="tc-accordion-body" style={{ maxHeight: open ? '1000px' : '0' }}>
                <div className="tc-accordion-inner">
                    {children}
                </div>
            </div>

            <style>{`
                .tc-accordion-item {
                    border: 1px solid rgba(29, 106, 136, 0.15);
                    border-radius: 10px;
                    margin-bottom: 10px;
                    overflow: hidden;
                    transition: box-shadow 0.3s ease;
                }
                .tc-accordion-item.tc-accordion-open {
                    box-shadow: 0 4px 20px rgba(29, 106, 136, 0.12);
                    border-color: rgba(29, 106, 136, 0.35);
                }
                .tc-accordion-trigger {
                    width: 100%;
                    background: linear-gradient(135deg, rgba(29, 106, 136, 0.05), rgba(0, 168, 204, 0.04));
                    border: none;
                    padding: 14px 20px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    cursor: pointer;
                    font-weight: 600;
                    font-size: 0.95rem;
                    color: #1d6a88;
                    text-align: left;
                    transition: background 0.25s ease;
                }
                .tc-accordion-trigger:hover {
                    background: linear-gradient(135deg, rgba(29, 106, 136, 0.1), rgba(0, 168, 204, 0.08));
                }
                .tc-accordion-open .tc-accordion-trigger {
                    background: linear-gradient(135deg, rgba(29, 106, 136, 0.12), rgba(0, 168, 204, 0.1));
                    color: #002536;
                }
                .tc-accordion-icon {
                    font-size: 0.75rem;
                    color: #00a8cc;
                    transition: transform 0.3s ease;
                    flex-shrink: 0;
                    margin-left: 12px;
                }
                .tc-accordion-icon.rotated {
                    transform: rotate(180deg);
                }
                .tc-accordion-body {
                    max-height: 0;
                    overflow: hidden;
                    transition: max-height 0.4s ease;
                }
                .tc-accordion-inner {
                    padding: 16px 20px 20px;
                    border-top: 1px solid rgba(29, 106, 136, 0.1);
                }
                .tc-accordion-inner p,
                .tc-accordion-inner ul {
                    margin-bottom: 10px;
                }
                .tc-accordion-inner ul {
                    padding-left: 20px;
                }
                .tc-accordion-inner ul li {
                    margin-bottom: 5px;
                    color: #555;
                    line-height: 1.6;
                }
            `}</style>
        </div>
    );
};

const PositionCard = ({ title, icon, responsibilities, requirements }) => {
    const [open, setOpen] = useState(false);

    return (
        <div className={`cr-position-card ${open ? 'cr-position-open' : ''}`}>
            <button className="cr-position-header" onClick={() => setOpen(!open)}>
                <div className="cr-position-title-wrap">
                    <span className="cr-position-icon">
                        <FontAwesomeIcon icon={icon} />
                    </span>
                    <span className="cr-position-title">{title}</span>
                </div>
                <span className={`cr-position-chevron ${open ? 'rotated' : ''}`}>
                    <FontAwesomeIcon icon={faChevronDown} />
                </span>
            </button>
            <div className="cr-position-body" style={{ maxHeight: open ? '800px' : '0' }}>
                <div className="cr-position-inner">
                    <div className="cr-position-cols">
                        <div className="cr-position-col">
                            <h6 className="cr-col-heading">Responsibilities</h6>
                            <ul>
                                {responsibilities.map((r, i) => <li key={i}>{r}</li>)}
                            </ul>
                        </div>
                        {requirements && (
                            <div className="cr-position-col">
                                <h6 className="cr-col-heading">Requirements</h6>
                                <ul>
                                    {requirements.map((r, i) => <li key={i}>{r}</li>)}
                                </ul>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <style>{`
                .cr-position-card {
                    border: 1px solid rgba(29, 106, 136, 0.18);
                    border-radius: 12px;
                    margin-bottom: 14px;
                    overflow: hidden;
                    transition: box-shadow 0.3s ease, border-color 0.3s ease;
                    background: #fff;
                }
                .cr-position-card.cr-position-open {
                    box-shadow: 0 6px 28px rgba(29, 106, 136, 0.13);
                    border-color: rgba(0, 168, 204, 0.4);
                }
                .cr-position-header {
                    width: 100%;
                    background: linear-gradient(135deg, rgba(0, 37, 54, 0.03), rgba(0, 168, 204, 0.04));
                    border: none;
                    padding: 16px 22px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    cursor: pointer;
                    transition: background 0.25s ease;
                }
                .cr-position-header:hover {
                    background: linear-gradient(135deg, rgba(29, 106, 136, 0.07), rgba(0, 168, 204, 0.07));
                }
                .cr-position-open .cr-position-header {
                    background: linear-gradient(135deg, rgba(0, 37, 54, 0.07), rgba(0, 168, 204, 0.08));
                }
                .cr-position-title-wrap {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                }
                .cr-position-icon {
                    width: 36px;
                    height: 36px;
                    background: linear-gradient(135deg, var(--primary-color, #002536), var(--primary-hover, #1d6a88));
                    color: #fff;
                    border-radius: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 0.8rem;
                    flex-shrink: 0;
                }
                .cr-position-title {
                    font-weight: 700;
                    font-size: 1rem;
                    color: #002536;
                }
                .cr-position-chevron {
                    font-size: 0.75rem;
                    color: #00a8cc;
                    transition: transform 0.3s ease;
                    flex-shrink: 0;
                }
                .cr-position-chevron.rotated {
                    transform: rotate(180deg);
                }
                .cr-position-body {
                    max-height: 0;
                    overflow: hidden;
                    transition: max-height 0.4s ease;
                }
                .cr-position-inner {
                    padding: 20px 22px 24px;
                    border-top: 1px solid rgba(29, 106, 136, 0.1);
                }
                .cr-position-cols {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 24px;
                }
                @media (max-width: 576px) {
                    .cr-position-cols {
                        grid-template-columns: 1fr;
                    }
                }
                .cr-col-heading {
                    font-weight: 700;
                    color: var(--primary-color, #002536);
                    font-size: 0.85rem;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                    margin-bottom: 10px;
                    padding-bottom: 6px;
                    border-bottom: 2px solid rgba(0, 168, 204, 0.25);
                }
                .cr-position-inner ul {
                    padding-left: 18px;
                    margin: 0;
                }
                .cr-position-inner ul li {
                    color: #555;
                    line-height: 1.65;
                    margin-bottom: 6px;
                    font-size: 0.9rem;
                }
            `}</style>
        </div>
    );
};

export default function Careers() {

    const benefits = [
        { icon: faUsers, text: "Opportunities to work with international clients" },
        { icon: faStar, text: "Skill development and professional growth" },
        { icon: faBriefcase, text: "Friendly and supportive team environment" },
        { icon: faAward, text: "Performance-based incentives" },
        { icon: faClock, text: "Long-term career opportunities" },
    ];

    const positions = [
        {
            title: "Embroidery Digitizer",
            icon: faBriefcase,
            responsibilities: [
                "Digitizing logos for caps, jackets, and garments",
                "Selecting proper stitch types and densities",
                "Applying push and pull compensation",
                "Ensuring smooth machine production results",
                "Making revisions when required",
            ],
            requirements: [
                "Experience with embroidery digitizing software",
                "Strong understanding of embroidery techniques",
                "Attention to detail and quality control",
            ],
        },
        {
            title: "Vector Artist",
            icon: faStar,
            responsibilities: [
                "Convert low-resolution images into vector format",
                "Prepare artwork for printing and production",
                "Maintain clean and organized vector files",
            ],
            requirements: [
                "Experience with vector design software",
                "Strong design and illustration skills",
                "Ability to work with complex artwork",
            ],
        },
        {
            title: "Sales Representative",
            icon: faUsers,
            responsibilities: [
                "Communicate with customers via email and messaging",
                "Handle order inquiries and follow-ups",
                "Maintain strong relationships with clients",
                "Generate new leads and business opportunities",
            ],
            requirements: [
                "Strong communication skills",
                "Professional client handling",
                "Basic understanding of embroidery and vector services",
            ],
        },
        {
            title: "HR Management",
            icon: faShieldAlt,
            responsibilities: [
                "Hiring and onboarding employees",
                "Maintaining employee records",
                "Managing attendance and internal communication",
                "Supporting team development",
            ],
            requirements: null,
        },
        {
            title: "Team Leader",
            icon: faAward,
            responsibilities: [
                "Assign tasks to team members",
                "Monitor work progress and deadlines",
                "Ensure quality control before delivery",
                "Assist team members with technical issues",
            ],
            requirements: null,
        },
    ];

    return (
        <>
            <Header />

            <section className="breadcrumbsection">
                <div className='container'>
                    <h1>Careers</h1>
                    <ul className='breadcrumblinks'>
                        <li><Link to="/">Home</Link></li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Careers</li>
                    </ul>
                </div>
            </section>

            {/* ── Why Work With Us ── */}
            <section className="about-section cr-why-section">
                <div className="container">
                    <div className="cr-intro-wrap">
                        <h2 className="case-study-title cr-main-heading">Careers at Grand Indigo Embroidery</h2>
                        <p className="case-study-description">
                            At Grand Indigo Embroidery, we believe that a strong team creates exceptional results. We are always looking for talented and motivated individuals to join our growing team in the fields of embroidery digitizing, vector artwork, sales, and management.
                        </p>
                        <p className="case-study-description">
                            If you are passionate about creativity, quality, and professional growth, we welcome you to become part of our team.
                        </p>
                    </div>

                    <h3 className="case-study-title cr-section-heading">Why Work With Us</h3>
                    <p className="case-study-description">
                        Grand Indigo Embroidery offers a professional and supportive work environment where employees can develop their skills and grow within the company.
                    </p>

                    <div className="cr-benefits-grid">
                        {benefits.map((b, i) => (
                            <div className="cr-benefit-card" key={i}>
                                <span className="cr-benefit-icon">
                                    <FontAwesomeIcon icon={b.icon} />
                                </span>
                                <p className="cr-benefit-text">{b.text}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ── Available Positions ── */}
            <section className="about-section cr-positions-section">
                <div className="container">
                    <h3 className="case-study-title cr-section-heading">Available Positions</h3>
                    <p className="case-study-description cr-positions-intro">
                        Click on any position below to view responsibilities and requirements.
                    </p>
                    {positions.map((pos, i) => (
                        <PositionCard key={i} {...pos} />
                    ))}
                </div>
            </section>

            {/* ── Work Policies ── */}
            <section className="about-section cr-policies-section">
                <div className="container">
                    <h3 className="case-study-title cr-section-heading">Work Policies</h3>

                    <AccordionItem title="Quality Standards">
                        <p className="case-study-description">
                            All work must meet the quality standards of Grand Indigo Embroidery. Files may be returned for revision if quality requirements are not met.
                        </p>
                    </AccordionItem>

                    <AccordionItem title="Confidentiality">
                        <p className="case-study-description">
                            Employees must keep all client information, artwork, and company data strictly confidential.
                        </p>
                    </AccordionItem>

                    <AccordionItem title="Work Discipline">
                        <p className="case-study-description">
                            Professional behavior, punctuality, and respect within the team are required at all times.
                        </p>
                    </AccordionItem>

                    <AccordionItem title="Company Ownership of Files">
                        <p className="case-study-description">
                            All files created during employment belong to Grand Indigo Embroidery and cannot be shared or sold outside the company.
                        </p>
                    </AccordionItem>
                </div>
            </section>

            {/* ── Careers T&C ── */}
            <section className="about-section cr-tnc-section">
                <div className="container">
                    <h3 className="case-study-title cr-section-heading">Careers – Terms &amp; Conditions</h3>

                    <AccordionItem title="1. General Employment Policy">
                        <p className="case-study-description">
                            All employees working with Grand Indigo Embroidery must maintain professionalism, honesty, and commitment to company standards. Employees are expected to follow company policies, respect deadlines, and maintain the quality standards required by the organization.
                        </p>
                    </AccordionItem>

                    <AccordionItem title="2. Work Responsibility">
                        <p className="case-study-description">Each team member must perform their assigned duties responsibly.</p>
                        <ul>
                            <li><strong>Embroidery Digitizers:</strong> Responsible for creating accurate embroidery digitizing files based on client artwork and instructions. Digitizers must ensure proper stitch types, density, push and pull compensation, and machine-friendly results.</li>
                            <li><strong>Vector Artists:</strong> Responsible for converting raster images or sketches into clean vector formats. All vector files must be scalable, organized, and production-ready.</li>
                            <li><strong>Sales Representatives:</strong> Responsible for communicating with clients, managing orders, generating new leads, and ensuring client satisfaction. Sales representatives must maintain professional communication with customers at all times.</li>
                            <li><strong>HR Management:</strong> Responsible for recruitment, team coordination, employee records, attendance management, and maintaining a positive work environment.</li>
                            <li><strong>Team Leaders:</strong> Responsible for supervising team performance, ensuring work quality, distributing tasks, and assisting team members in meeting deadlines.</li>
                        </ul>
                    </AccordionItem>

                    <AccordionItem title="3. Work Quality Standards">
                        <p className="case-study-description">
                            Employees must maintain high-quality work standards. Any work that does not meet the company's quality requirements may be returned for revision.
                        </p>
                    </AccordionItem>

                    <AccordionItem title="4. Confidentiality Policy">
                        <p className="case-study-description">
                            All employees must keep client data, artwork, pricing, and company information strictly confidential. Sharing company files, designs, or client information without permission is strictly prohibited.
                        </p>
                    </AccordionItem>

                    <AccordionItem title="5. Attendance and Work Discipline">
                        <p className="case-study-description">
                            Employees are expected to maintain regular attendance and follow the assigned work schedule. Continuous delays, negligence, or absence without notice may result in disciplinary action.
                        </p>
                    </AccordionItem>

                    <AccordionItem title="6. Communication Policy">
                        <p className="case-study-description">
                            Professional communication must be maintained between team members and with clients. Miscommunication, disrespectful language, or unprofessional behavior will not be tolerated.
                        </p>
                    </AccordionItem>

                    <AccordionItem title="7. Payment & Compensation">
                        <p className="case-study-description">
                            Payment terms will be communicated according to the employee's role and agreement with the company. Payments are processed based on completed work, performance, or monthly salary depending on the role.
                        </p>
                    </AccordionItem>

                    <AccordionItem title="8. Performance Evaluation">
                        <p className="case-study-description">
                            Employee performance will be reviewed periodically based on work quality, punctuality, communication, and overall contribution to the company.
                        </p>
                    </AccordionItem>

                    <AccordionItem title="9. Company Property & Work Files">
                        <p className="case-study-description">
                            All work files created during employment belong to Grand Indigo Embroidery. Employees are not allowed to reuse, sell, or distribute company designs or files outside the organization.
                        </p>
                    </AccordionItem>

                    <AccordionItem title="10. Termination Policy">
                        <p className="case-study-description">Grand Indigo Embroidery reserves the right to terminate employment in cases of:</p>
                        <ul>
                            <li>Violation of company policies</li>
                            <li>Poor performance or repeated mistakes</li>
                            <li>Breach of confidentiality</li>
                            <li>Unprofessional conduct</li>
                        </ul>
                        <p className="case-study-description">
                            Employees may also resign by providing appropriate notice as per company policy.
                        </p>
                    </AccordionItem>
                </div>
            </section>

            {/* ── Join Our Team CTA ── */}
            <section className="cr-cta-section">
                <div className="container">
                    <div className="cr-cta-card">
                        <div className="cr-cta-icon-wrap">
                            <FontAwesomeIcon icon={faEnvelope} />
                        </div>
                        <h3 className="cr-cta-heading">Join Our Team</h3>
                        <p className="cr-cta-text">
                            If you are interested in joining Grand Indigo Embroidery, please send your application along with your portfolio and experience details. Our team will review your application and contact you if your profile matches our requirements.
                        </p>
                        <a href="mailto:grandindigoofficial@gmail.com" className="btn btn-primary cr-cta-btn">
                            <FontAwesomeIcon icon={faEnvelope} style={{ marginRight: '8px' }} />
                            grandindigoofficial@gmail.com
                        </a>
                    </div>
                </div>

                <style>{`
                    /* ── Why Work With Us ── */
                    .cr-main-heading {
                        font-size: 1.8rem !important;
                        margin-bottom: 16px !important;
                    }
                    .cr-section-heading {
                        margin-top: 0 !important;
                        margin-bottom: 16px !important;
                    }
                    .cr-intro-wrap {
                        margin-bottom: 40px;
                    }
                    .cr-benefits-grid {
                        display: grid;
                        grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
                        gap: 16px;
                        margin-top: 20px;
                        margin-bottom: 8px;
                    }
                    .cr-benefit-card {
                        display: flex;
                        align-items: flex-start;
                        gap: 12px;
                        padding: 16px 18px;
                        border: 1px solid rgba(29, 106, 136, 0.15);
                        border-radius: 10px;
                        background: linear-gradient(135deg, rgba(0, 37, 54, 0.02), rgba(0, 168, 204, 0.04));
                        transition: box-shadow 0.3s ease, border-color 0.3s ease;
                    }
                    .cr-benefit-card:hover {
                        box-shadow: 0 4px 18px rgba(29, 106, 136, 0.12);
                        border-color: rgba(0, 168, 204, 0.35);
                    }
                    .cr-benefit-icon {
                        width: 34px;
                        height: 34px;
                        background: linear-gradient(135deg, var(--primary-color, #002536), var(--primary-hover, #1d6a88));
                        color: #fff;
                        border-radius: 8px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 0.78rem;
                        flex-shrink: 0;
                        margin-top: 2px;
                    }
                    .cr-benefit-text {
                        margin: 0;
                        font-size: 0.88rem;
                        color: #444;
                        line-height: 1.5;
                    }

                    /* ── Positions ── */
                    .cr-positions-intro {
                        margin-bottom: 20px !important;
                    }

                    /* ── Section spacing ── */
                    .cr-why-section,
                    .cr-positions-section,
                    .cr-policies-section,
                    .cr-tnc-section {
                        padding-top: 50px !important;
                        padding-bottom: 10px !important;
                    }

                    /* ── CTA ── */
                    .cr-cta-section {
                        padding: 50px 0 70px;
                    }
                    .cr-cta-card {
                        background: linear-gradient(135deg, var(--primary-color, #002536) 0%, var(--primary-hover, #1d6a88) 100%);
                        border-radius: 16px;
                        padding: 50px 40px;
                        text-align: center;
                        color: #fff;
                        max-width: 700px;
                        margin: 0 auto;
                        box-shadow: 0 12px 40px rgba(0, 37, 54, 0.25);
                    }
                    .cr-cta-icon-wrap {
                        width: 60px;
                        height: 60px;
                        background: rgba(255, 255, 255, 0.15);
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 1.4rem;
                        margin: 0 auto 18px;
                    }
                    .cr-cta-heading {
                        color: #fff !important;
                        font-size: 1.5rem !important;
                        margin-bottom: 14px !important;
                    }
                    .cr-cta-text {
                        color: rgba(255,255,255,0.85);
                        font-size: 0.95rem;
                        line-height: 1.7;
                        margin-bottom: 28px;
                    }
                    .cr-cta-btn {
                        background: rgba(255,255,255,0.15) !important;
                        border: 2px solid rgba(255,255,255,0.5) !important;
                        color: #fff !important;
                        padding: 12px 28px !important;
                        border-radius: 8px !important;
                        font-weight: 600 !important;
                        font-size: 0.95rem !important;
                        transition: background 0.25s ease, border-color 0.25s ease !important;
                        text-decoration: none;
                        display: inline-block;
                    }
                    .cr-cta-btn:hover {
                        background: rgba(255,255,255,0.25) !important;
                        border-color: rgba(255,255,255,0.8) !important;
                        color: #fff !important;
                    }
                `}</style>
            </section>

            <Newsletter />
            <Footer />
        </>
    )
}